import { render } from "./SpotlightLayout.vue?vue&type=template&id=5873f3f4&scoped=true&ts=true"
import script from "./SpotlightLayout.vue?vue&type=script&lang=ts"
export * from "./SpotlightLayout.vue?vue&type=script&lang=ts"

import "./SpotlightLayout.vue?vue&type=style&index=0&id=5873f3f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5873f3f4"]])

export default __exports__